import { Divider as MuiDivider, styled } from '@mui/material'
import { SuccessAlert } from '@datasets/dataset-details/datasetHistoryV2/styled'

export const Alert = styled(SuccessAlert)`
  margin-left: 30px;
  margin-top: 10px;
`

export const Divider = styled(MuiDivider)`
  margin-top: 5px;
  margin-bottom: 5px;
`
